import { load } from './component-loader'

const SchoolIndex = load('schoolSupplies/SchoolIndex')
const SelectSchool = load('schoolSupplies/SelectSchool')
const SelectGrade = load('schoolSupplies/SelectGrade')
const SelectItems = load('schoolSupplies/SelectItems')
const initialTitle = " | Eichlers  ";

export default[
    {
        path:"/school",
        name:"SchoolIndex",
        component:SchoolIndex,
        meta:{title:"School Supplies Department" + initialTitle},
        props:true
    },
    {
        path:"/school/select-your-school/:country/:zip",
        name:"SelectSchool",
        component:SelectSchool,
        meta:{title:"School Supplies Department" + initialTitle},
    },
    {
        path:"/school/select-your-grade/:grade_id",
        name:"SelectGrade",
        component:SelectGrade,
        meta:{title:"School Supplies Department" + initialTitle},
    },
    {
        path:"/school/select-your-supplies/:grade_id/:list_id",
        name:"SelectItems",
        component:SelectItems,
        meta:{title:"School Supplies Department" + initialTitle},
    }
]


// WEBPACK FOOTER //
// ./resources/js/router/schoolSupplies.js